<template>
  <q-card v-bind="props" class="q-mb-sm flex order-card" flat bordered style="padding: 0">
    <div class="card-left-area">
      <p class="card-num text-right">{{ props.num + 1 }}</p>
    </div>
    <q-card-section
      class="order-headercard"
      style="
        border-left: 1px solid var(--q-whiteBorder);
        border-radius: 0;
        padding-bottom: 0;
        width: calc(100% - 45px);
        padding: 10px 0;
      "
    >
      <div class="row justify-between" style="padding: 0 10px">
        <div class="flex items-center" style="width: 140px; margin-right: 15px">
          <p
            class="q-mb-none text-center"
            style="font-weight: bold; letter-spacing: 1px; font-size: 1rem"
          >
            {{ data.atto_id }}
          </p>
        </div>
        <ApplyLowLabel
          v-if="props.quoteFlg"
          :classification-code="data.reg_group_code"
          :reg-name="data.reg_group_name"
          :prtr-name="data.prtr_name"
          :ishl-name="data.ishl_name"
          :style="
            'width: calc(100% - 250px);' + (data.reg_group_code === null ? 'display: none;' : '')
          "
        />
        <div v-else class="app-low-right q-gutter-x-xs" style="width: calc(100% - 250px)">
          <div v-if="data.reg_group_code === '3'" class="app-lows">
            <label class="low-deleterious">{{ data.reg_group_name }}</label>
          </div>
          <div
            v-if="
              (data.reg_group_code === '5' ||
                data.reg_group_code === '6' ||
                (data.prtr_name !== null && data.prtr_name !== '')) &&
              data.reg_group_code !== '2'
            "
            class="app-lows"
          >
            <label class="low-prtr">{{ data.prtr_name }}</label>
          </div>
          <div
            v-if="
              (data.reg_group_code === '7' || (data.ishl_name !== null && data.ishl_name !== '')) &&
              data.reg_group_code !== '2'
            "
            class="app-lows"
          >
            <label class="low-safety">{{ data.ishl_name }}</label>
          </div>
          <div
            v-if="
              data.reg_group_code === '1' ||
              data.reg_group_code === '4' ||
              data.reg_group_code === '8'
            "
            class="app-lows flex items-center justify-center"
            style="width: 60%; margin: 0px"
          >
            <label
              class="low-none flex items-center justify-center"
              style="
                background-color: rgba(210, 210, 210, 0.8);
                font-size: 14px;
                line-height: 1.5;
                border-radius: 0;
                font-weight: bold;
                letter-spacing: 1px;
                padding: 4px 0;
                width: 100%;
              "
              >取り扱いは中止になりました。</label
            >
          </div>
          <div
            v-else-if="data.reg_group_code === '2'"
            class="app-lows flex items-center justify-center"
            style="width: 480px; margin: 0px"
          >
            <label
              class="low-none flex items-center justify-center"
              style="
                background-color: rgba(210, 210, 210, 0.8);
                padding: 4px 0;
                letter-spacing: 1px;
                font-size: 14px;
                line-height: 1.5;
                width: 100%;
              "
              >毒物は注文することができませんのでお問い合わせください。</label
            >
          </div>
        </div>
        <div class="deletebtn" style="margin: 0">
          <q-btn
            icon="mdi-trash-can-outline"
            label="削除"
            outline
            :disable="poType === 'PO_RE_ARIBA' || cartLimitFlg === true"
            style="color: var(--q-delete); height: 30px; min-height: unset; background-color: white"
            @click="deleteOrder()"
          />
        </div>
      </div>
      <div class="row items-start order-card-container q-mt-sm q-mb-sm">
        <div class="row" style="width: 140px; margin-right: 15px; margin-top: -2px">
          <AtomImage :exatoms="data.structure_svg" />
        </div>
        <div class="col q-gutter-y-sm">
          <div class="row">
            <label class="q-mr-md card-title">CAS No.</label>
            <span>{{ data.cas ? data.cas : '-' }}</span>
          </div>
          <div class="row q-gutter-x-xl" style="margin-top: 0">
            <div class="row items-center supplier-name">
              <label class="q-mr-md card-title">サプライヤ</label>
              <span>{{ data.supplier_name ? data.supplier_name : '-' }}</span>
            </div>
            <div class="row items-center supplier-code">
              <label class="q-mr-md card-title">サプライヤ商品コード</label>
              <span>{{ data.id_number ? data.id_number : '-' }}</span>
            </div>
          </div>
          <div class="row items-center">
            <label class="q-mr-md card-title">化学名</label>
            <span>{{ data.name1 ? data.name1 : '-' }}</span>
          </div>
          <div class="row">
            <div class="q-mr-sm row items-center" style="width: 268px">
              <label class="q-mr-md card-title">容量</label>
              <span>{{ data.capacity ? data.capacity : 'ご希望容量' }}</span>
            </div>
            <div class="q-mr-sm row items-center">
              <label class="q-mr-md card-title">純度</label>
              <span>{{ data.purity ? data.purity : '-' }}</span>
            </div>
          </div>
          <div class="row justify-between">
            <div class="row items-center">
              <label class="q-mr-md text-weight-bold card-title">納期</label>
              <span :class="!data.selling_price && 'order-card-inquiry-required'">
                {{
                  data.standard_delivery_time_name
                    ? data.standard_delivery_time_name
                    : '要問い合わせ'
                }}
              </span>
            </div>
            <div class="text-weight-bold row items-center">
              <label class="q-mr-md card-title">納入価格（税抜）</label>
              <span
                style="font-size: 1.1rem; letter-spacing: 1px"
                :class="!data.selling_price && 'order-card-inquiry-required'"
              >
                {{
                  data.selling_price
                    ? `¥${commaFormat(Number(data.selling_price))}`
                    : '要問い合わせ'
                }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row justify-between order-bottom"
        style="border-top: 1px solid var(--q-whiteBorder); padding: 10px 10px 0"
      >
        <button
          v-if="poType !== 'PO_RE_ARIBA'"
          :class="
            'comment-btn flex items-center justify-center q-gutter-x-sm ' +
            (commentShownFlg ? 'comment-hidden' : '')
          "
          @click="commentShownFlg ? (commentShownFlg = false) : (commentShownFlg = true)"
        >
          <q-icon color="black" size="20px" name="mdi-chevron-down" />
          <p class="q-mb-none">コメントを入力</p>
        </button>
        <button
          v-else
          :class="'comment-btn flex items-center justify-center q-gutter-x-sm comment-hidden'"
          @click="commentShownFlg = true"
        >
          <q-icon color="black" size="20px" name="mdi-chevron-down" />
          <p class="q-mb-none">コメント</p>
        </button>
        <div class="flex justify-end items-center" style="width: calc(100% - 150px)">
          <div
            v-if="quoteFlg"
            class="flex items-center des-capacity"
            style="width: 200px; margin-right: 20px"
          >
            <label class="text-weight-bold requier" style="font-size: 0.8rem; margin-right: 10px"
              >希望容量</label
            >
            <q-input
              v-model="inputData.desired_capacity"
              outlined
              clearable
              dense
              maxlength="30"
              :disable="!quoteFlg || cartLimitFlg === true"
              pattern="^[0-9A-Za-z]+$"
              style="width: 110px"
              class="input-area left-input"
              @blur="inputComment"
            />
          </div>
          <div class="flex items-center" style="width: 170px; margin-right: -5px">
            <label
              v-if="poType === 'PO_RE_ARIBA'"
              class="text-weight-bold"
              style="font-size: 0.8rem; margin-right: 10px"
              >数量</label
            >
            <label
              v-else
              class="text-weight-bold requier"
              style="font-size: 0.8rem; margin-right: 10px"
              >数量</label
            >
            <q-input
              v-model="inputData.desired_quantity"
              outlined
              dense
              mask="##"
              maxlength="2"
              input-class="text-right"
              class="input-area"
              style="width: 100px"
              :disable="poType === 'PO_RE_ARIBA' || cartLimitFlg === true"
              @blur="inputComment"
            />
          </div>
        </div>
        <div
          v-if="poType === 'PO_RE_ARIBA'"
          :class="quoteFlg ? 'inquiry-comment-area' : 'order-comment-area'"
          style="width: 100%; margin-top: 8px; padding-left: 40px"
        >
          <q-input
            v-model="inputData.comment"
            outlined
            clearable
            dense
            counter
            rows="1"
            maxlength="200"
            type="textarea"
            class="input-area left-input"
            :disable="poType === 'PO_RE_ARIBA' || cartLimitFlg === true"
            @blur="inputComment"
          />
        </div>
        <div
          v-else-if="commentShownFlg"
          :class="quoteFlg ? 'inquiry-comment-area' : 'order-comment-area'"
          style="width: 100%; margin-top: 8px; padding-left: 40px"
        >
          <q-input
            v-model="inputData.comment"
            outlined
            clearable
            dense
            counter
            rows="1"
            maxlength="200"
            type="textarea"
            class="input-area left-input"
            :disable="poType === 'PO_RE_ARIBA' || cartLimitFlg === true"
            @blur="inputComment"
          />
        </div>
      </div>
    </q-card-section>
  </q-card>
</template>
<script setup lang="ts">
import { ref, computed, inject } from 'vue';
import AtomImage from '../images/AtomImage.vue';
import ApplyLowLabel from '../label/ApplyLowLabel.vue';
import commaFormat from '../../common/utils/numberUtils';

// データ interface
interface Data {
  cart_result_detail_atto_id: string;
  atto_id: string;
  structure_svg: string;
  cas: string;
  reg_group_code: string;
  reg_group_name: string;
  prtr_name: string;
  ishl_name: string;
  supplier_name: string;
  id_number: string;
  name1: string;
  capacity: string;
  packing: string;
  purity: string;
  selling_price: string;
  standard_delivery_time_name: string;
  desired_capacity: string | null;
  desired_quantity: string | null;
  comment: string;
}

interface Props {
  // 番号
  num: number;
  // データ
  data: Data;
  // 問い合わせフラグ
  quoteFlg: boolean;
}
const props = defineProps<Props>();

const commentShownFlg = ref(false);

const inputData = ref(computed(() => props.data));

const emit = defineEmits<{
  (event: 'delete'): void;
  (event: 'inputComment'): void;
}>();

// 削除
const deleteOrder = () => {
  emit('delete');
};

// コメント入力
const inputComment = () => {
  emit('inputComment');
};
// パンチアウトタイプ
const poType = inject('poType');
const cartLimitFlg = inject('cartLimitFlg');

const init = () => {
  if (poType === 'PO_RE_ARIBA') {
    commentShownFlg.value = true;
  }
};

init();
</script>
<style scoped>
.card-left-area {
  width: 30px;
  height: 100%;
  margin: 15px 10px;
  margin-left: 5px;
}
.card-num {
  margin: 0;
  font-size: 1.1rem;
  letter-spacing: 1px;
}
.order-headercard {
  padding: 0 12px 10px;
}
.order-card-container {
  padding: 0 12px;
}
.order-bottom {
  padding: 0 12px;
}
.order-card label {
  font-weight: 600;
}
.order-card span {
  word-break: break-all;
}

.order-card-inquiry-required {
  color: var(--q-dark);
}
.order-card-disable {
  opacity: 0.3;
}

.deletebtn button {
  width: 86px;
  padding: 0;
}

.order-comment-area {
  padding-left: 40px;
}

label.card-title {
  min-width: 70px;
  display: block;
}

.comment-btn {
  width: 150px;
  cursor: pointer;
  display: flex;
  border: none;
  background: transparent;
}

.comment-btn.comment-hidden .q-icon {
  transform: rotate(180deg);
}
.comment-btn .q-icon {
  border-radius: 50%;
  border: 1px solid var(--q-dark);
}

.supplier-name,
.supplier-code {
  margin-top: 8px;
  flex-wrap: nowrap;
}
</style>
<style>
.order-headercard .label-text {
  display: none;
}

.csr00100-order-form .comment-btn .q-icon:before {
  transform: scale(1.2);
  padding-top: 1px;
}

.order-card .q-card__section {
  width: calc(100% - 50px);
}

.inquiry-comment-area .q-field__control,
.order-comment-area .q-field__control {
  align-items: center;
}

.order-comment-area .input-area.q-field .q-field__native,
.inquiry-comment-area .input-area.q-field .q-field__native {
  padding-top: 8px;
  padding-bottom: 8px;
}

/* 適用法令ラベル用（後で消す） */
.csr00100-order-form .app-low-cotainer {
  display: flex;
}

.csr00100-order-form .app-low-cotainer .app-lows {
  margin-right: 5px;
}
</style>
